module.exports = __webpack_public_path__ + "img/credit-card.fbdb6c95.svg";